import { render, staticRenderFns } from "./DescriptionsParser.vue?vue&type=template&id=0ab5d098&scoped=true&"
import script from "./DescriptionsParser.vue?vue&type=script&lang=js&"
export * from "./DescriptionsParser.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionsParser.vue?vue&type=style&index=0&id=0ab5d098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5d098",
  null
  
)

export default component.exports